import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { LegalInvestigationsRevokedModel } from './types';
import { legalInvestigationsRevokedItemValidator } from './validators/item';

const legalInvestigationsRevokedValidator: ValidateJSModel<LegalInvestigationsRevokedModel> = {
  HasRevocations: {
    presence: true,
    hasValue: { validator: hasYesOrNo },
  },
  List: (value, attributes) => {
    // Only required if HasRevocations is yes
    if (attributes?.HasRevocations && attributes?.HasRevocations.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalInvestigationsRevokedItemValidator },
      };
    }

    return {};
  },
};
export default legalInvestigationsRevokedValidator;
